import CryptoJS from 'crypto-js';
import moment from 'moment';

export const getHashKey = (fileType = '') => {
    const dateNow = moment().format('YYYY-MM-DD');
    const hashKey = "e58a219892b0795a629b84a1279ea4702581c0cacfb1b2432327a080";
    const dataToSign = `${dateNow}-${hashKey}-${fileType}`;

    // Crear el hash HMAC-SHA1
    const secretKey = CryptoJS.enc.Utf8.parse(hashKey);
    const signature = CryptoJS.HmacSHA1(dataToSign, secretKey);
    const hexSignature = signature.toString(CryptoJS.enc.Hex);

    return hexSignature;
};
